"use client";

import { TrendingUp } from "lucide-react";

import {
	CartesianGrid,
	Line,
	LineChart,
	XAxis,
	YAxis,
	ResponsiveContainer,
	ReferenceLine,
	Legend, // Added import
} from "recharts";

import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";

import {
	ChartContainer,
	ChartLegend,
	ChartLegendContent,
	ChartTooltip,
	ChartTooltipContent,
} from "@/components/ui/chart";

import type { FinancialPlan } from "@/interfaces/dashboard";
export function ActionPlan({ data }: { data: FinancialPlan[] }) {
	console.log(data);

	const formatLargeNumber = (value: number) => {
		if (value === 0) return "0";
		if (value >= 1000000000000)
			return `${(value / 1000000000000).toFixed(0)} ໂກດ`;
		if (value >= 1000000000) return `${(value / 1000000000).toFixed(0)} ຕື້`;
		if (value >= 1000000) return `${(value / 1000000).toFixed(0)} ລ້ານ`;
		if (value >= 100000) return `${(value / 100000).toFixed(0)} ແສນ`;
		if (value >= 1000) return `${(value / 1000).toFixed(0)} ພັນ`;
		if (value <= -1000000000000)
			return `${(value / 1000000000000).toFixed(0)} ໂກດ`;
		if (value <= -1000000000) return `${(value / 1000000000).toFixed(0)} ຕື້`;
		if (value <= -1000000) return `${(value / 1000000).toFixed(0)} ລ້ານ`;
		if (value <= -100000) return `${(value / 100000).toFixed(0)} ແສນ`;
		if (value <= -1000) return `${(value / 1000).toFixed(0)} ພັນ`;
		if (value >= -100 && value < 0) return `-${(value).toFixed(0)}`;
		return value.toString();
	};

	const chartConfig = {
		totalExpense: {
			label: "ລາຍຈ່າຍ",
			color: "#008000",
		},
		totalIncome: {
			label: "ລາຍຮັບ",
			color: "#CA8A04",
		},
		totalProfit: {
			label: "ກຳໄລ/(ຂາດທຶນ)ສຸດທິ",
			color: "#007AFF",
		},
	};

	return (
		<Card>
			<CardHeader>
				<CardTitle>ແຜນດຳເນີນງານລວມທັງໝົດ</CardTitle>
				<CardDescription>ລາຍລະອຽດລາຍງານແຜນດຳເນີນງານ</CardDescription>
			</CardHeader>
			<CardContent>
				<ChartContainer
					config={chartConfig}
					className="aspect-[4/3] h-[500px] w-full"
				>
					<ResponsiveContainer width="100%" height="100%">
						<LineChart
							data={data}
							margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
						>
							<CartesianGrid strokeDasharray="3 3" />
							<XAxis dataKey="yearly" />
							<YAxis tickFormatter={formatLargeNumber} />
							<ChartTooltip
								content={
									<ChartTooltipContent
										valueFormatter={(value) => formatLargeNumber(Number(value))}
									/>
								}
							/>
							<Line
								type="monotone"
								dataKey="totalExpense"
								stroke="hsl(var(--chart-1))"
								strokeWidth={2}
								dot={false}
							/>
							<Line
								type="monotone"
								dataKey="totalIncome"
								stroke="hsl(var(--chart-2))"
								strokeWidth={2}
								dot={false}
							/>
							<Line
								type="monotone"
								dataKey="totalProfit"
								stroke="hsl(var(--chart-3))"
								strokeWidth={2}
								dot={false}
							/>
							<ChartLegend content={<ChartLegendContent />} />
						</LineChart>
					</ResponsiveContainer>
				</ChartContainer>
			</CardContent>
		</Card>
	);
}
